import { render, staticRenderFns } from "./ventaFilters.vue?vue&type=template&id=4831c7fe"
import script from "./ventaFilters.vue?vue&type=script&lang=js"
export * from "./ventaFilters.vue?vue&type=script&lang=js"
import style0 from "./ventaFilters.vue?vue&type=style&index=0&id=4831c7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports